import { Button } from "@/components/ui/button";
export function Hero() {
  return <div className="text-center">
      <div className="flex justify-center mb-6">
        <img alt="Everest Logo" className="h-64 w-auto" // Changed from h-32 to h-64 (100% larger)
      src="/lovable-uploads/3c4be082-df12-4713-9244-f5b63101f4f4.png" />
      </div>
      <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
        Intelligent Auto Solutions Platform
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600">
        Streamline your automotive business with advanced ADAS features, calibration management, and intelligent estimating tools.
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <Button variant="default" className="bg-everest-teal hover:bg-everest-teal/90">
          Get started
        </Button>
        <Button variant="outline">Learn more</Button>
      </div>
    </div>;
}